import React from 'react'

import {
  Input,
  InputLeftElement,
  InputGroup,
  InputRightElement,
  Flex,
  useTheme,
  FlexProps,
} from '@chakra-ui/react'
import { FiSearch, FiX } from 'react-icons/fi'

import useDebounce from 'src/core/hooks/useDebounce'

interface IProps extends Omit<FlexProps, 'onChange'> {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  isDisabled?: boolean
  delay?: number
}
export const SearchBar: React.FC<IProps> = (props) => {
  const { value, onChange, placeholder, isDisabled, delay, ...rest } = props

  const { colors } = useTheme()
  const [searchTerm, setSearchTerm] = React.useState<string>(value)
  const debouncedSearchTerm = useDebounce(searchTerm, delay)

  const searchTermRef = React.useRef(debouncedSearchTerm)

  React.useEffect(() => {
    setSearchTerm(value)
  }, [value])

  React.useEffect(() => {
    if (searchTermRef.current !== debouncedSearchTerm) {
      searchTermRef.current = debouncedSearchTerm
      onChange(debouncedSearchTerm)
    }
  }, [debouncedSearchTerm, onChange])

  return (
    <Flex alignItems="center" {...rest}>
      <InputGroup size="sm">
        <InputLeftElement size="sm" pointerEvents="none">
          <FiSearch size={16} color={colors.gray[isDisabled ? '500' : '600']} />
        </InputLeftElement>
        <Input
          size="sm"
          type="text"
          name="searchTerm"
          value={searchTerm || ''}
          width="100%"
          placeholder={placeholder}
          onChange={({ target }) => {
            setSearchTerm(target.value)
          }}
          isDisabled={isDisabled}
        />

        {/* Reset for search term only */}
        {!!searchTerm && (
          <InputRightElement
            size="sm"
            pointerEvents="all"
            cursor="default"
            transition="transform 300ms"
            _hover={{ transform: 'scale(1.2)' }}
            onClick={() => setSearchTerm('')}
          >
            <FiX size={16} color={colors.gray['500']} />
          </InputRightElement>
        )}
      </InputGroup>
    </Flex>
  )
}

SearchBar.defaultProps = {
  placeholder: 'Search...',
  isDisabled: false,
  delay: 750,
  width: '100%',
}

export default SearchBar
